module.exports = __webpack_public_path__ + "img/mispos.ec6ae77b.svg";